export const NEW_MATCH_LOCAL = 'NEW_MATCH_LOCAL';
export const newMatchLocal = (gameroom, location, roster)=>({
    type: NEW_MATCH_LOCAL,
    gameroom,
    location
});

export const JOIN_GAME_LOCAL = 'JOIN_GAME_LOCAL';
export const joinGameLocal = (gameroom) => ({
    type: JOIN_GAME_LOCAL,
    gameroom
});

export const ADD_TO_ROSTER_SOCKET = "ADD_TO_ROSTER_SOCKET";
export const addToRosterSocket = (socket, gameroom, gamertag)=>({
    type: ADD_TO_ROSTER_SOCKET,
    socket,
    gameroom,
    gamertag
});

export const ADD_TO_ROSTER_LOCAL = 'ADD_TO_ROSTER_LOCAL';
export const addToRosterLocal = (roster) =>({
    type: ADD_TO_ROSTER_LOCAL,
    roster
});

export const UPDATE_TEE_SCORE_SOCKET = "UPDATE_TEE_SCORE_SOCKET";
export const updateTeeScoreSocket = (socket, gameroom, gamertag, tee, score)=>({
    type: UPDATE_TEE_SCORE_SOCKET,
    socket,
    gameroom,
    gamertag,
    tee,
    score
});

export const UPDATE_TEE_SCORE_LOCAL = 'UPDATE_TEE_SCORE_LOCAL';
export const updateTeeScoreLocal = (gamertag, scoreArray)=>({
    type: UPDATE_TEE_SCORE_LOCAL,
    gamertag,
    scoreArray
});

export const LEAVE_GAME_LOCAL = 'LEAVE_GAME_LOCAL';
export const leaveGameLocal = (payload)=>({
    type: LEAVE_GAME_LOCAL,
    payload
});

export const RESET_MATCH_STATE = 'RESET_MATCH_STATE';
export const resetMatchState = () =>({
    type: RESET_MATCH_STATE
});


// WEBPACK FOOTER //
// ./src/actions/matchManagement.js